document.addEventListener('DOMContentLoaded', function () {
  // Activa/desactiva el estado "scrolled" según la posición
  function setHeaderState() {
    var scrolled = (window.scrollY || document.documentElement.scrollTop) > 10;
    document.documentElement.classList.toggle('scrolled', scrolled);
  }
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  // Menú móvil: mantener fondo sólido al abrir
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest('button[aria-controls], button[aria-expanded], [data-drawer-toggle], .header__toggle');
    if (!t) return;
    setTimeout(function(){
      var isOpen = !!document.querySelector('button[aria-expanded="true"], [data-drawer][open]');
      document.documentElement.classList.toggle('menu-open', isOpen);
    }, 50);
  });
});
